import { wrapWithLayout, wrapWithProvider } from "./src/wrap-with-provider";

export const wrapRootElement = wrapWithProvider;
export const wrapPageElement = wrapWithLayout;